import React from 'react';
import GroupIcon from './GroupIcon';
import SelectEntityOption from '../components/SelectEntityOption';
import { GroupMatchKey } from '../search/entitySearch/localEntitySearch';
import LocalSearchHighlight from '../search/LocalSearchHighlight';
import type { FuzzySearchMatch } from '../utils/search/fuzzySearch';

interface GroupSelectOptionProps {
  group: { name: string };
  matches?: readonly FuzzySearchMatch[];
}

const GroupSelectOption = React.forwardRef<
  HTMLDivElement,
  GroupSelectOptionProps
>(({ group, matches, ...props }: GroupSelectOptionProps, ref) => (
  <SelectEntityOption
    {...props}
    icon={<GroupIcon />}
    label={
      <LocalSearchHighlight
        matches={matches}
        matchKey={GroupMatchKey.Name}
        defaultValue={group.name}
      />
    }
    ref={ref}
  />
));

export default GroupSelectOption;
